export const sceneDescriptions = [
  "A digital map of Japan with Mount Fuji and cherry blossoms appearing gracefully",
  "A bustling cyberpunk marketplace with neon signs reflecting on wet streets",
  "An ancient library with floating books and magical dust particles",
  "A serene underwater coral reef with colorful fish swimming peacefully",
  "A futuristic space station orbiting a distant planet with aurora effects",
  "A cozy coffee shop during a rainy afternoon with warm lighting",
  "A mystical forest with glowing mushrooms and fairy lights",
  "A vintage train traveling through mountain landscapes at sunset",
  "A modern art gallery with interactive holographic displays",
  "A peaceful zen garden with flowing water and bamboo"
];

export const compositions = [
  "Wide shot",
  "Medium shot",
  "Close-up",
  "Extreme close-up",
  "Bird's eye view",
  "Low angle",
  "High angle",
  "Over-the-shoulder",
  "Dutch angle",
  "Tracking shot"
];

export const cameraMovements = [
  "Pan Right – Horizontal swivel to the right from a fixed point",
  "Pan Left – Horizontal swivel to the left from a fixed point",
  "Tilt Up – Vertical swivel upward from a fixed point",
  "Tilt Down – Vertical swivel downward from a fixed point",
  "Dolly In – Camera moves forward toward the subject",
  "Dolly Out – Camera moves backward away from the subject",
  "Truck Left – Camera slides left along a horizontal path",
  "Truck Right – Camera slides right along a horizontal path",
  "Crane Up – Camera rises vertically from a lower position",
  "Crane Down – Camera lowers vertically from a higher position",
  "Arc Left – Camera curves around the subject to the left",
  "Arc Right – Camera curves around the subject to the right",
  "Zoom In – Lens zooms in without moving the camera",
  "Zoom Out – Lens zooms out without moving the camera",
  "Handheld – Slightly shaky motion for realism or tension",
  "Steadicam Walk – Smooth walking movement following the subject",
  "360 Spin – Full circle movement around the subject",
  "Overhead Drop – Direct overhead camera descends toward the scene",
  "Low Angle Rise – Camera lifts from a low angle for dramatic effect",
  "Whip Pan – Fast, blurry horizontal pan to imply speed or transition"
];

export const visualStyles = [
  "Hyper-realistic",
  "Cinematic",
  "Anime style",
  "Oil painting",
  "Watercolor",
  "Minimalist",
  "Retro vintage",
  "Film noir",
  "Impressionist",
  "Digital art",
  "3D Render (Unreal Engine 5)",
  "Stop Motion",
  "Cyberpunk 2077 Style",
  "Studio Ghibli Style"
];

export const lightingStyles = [
  "Backlit",
  "Golden hour",
  "Dramatic shadows",
  "Soft natural light",
  "Neon lighting",
  "Candlelight",
  "Studio lighting",
  "Moonlight",
  "Harsh sunlight",
  "Ambient lighting",
  "Volumetric lighting",
  "Rembrandt lighting"
];

export const environments = [
  "Crowded marketplace",
  "Serene mountain lake",
  "Urban rooftop",
  "Dense forest",
  "Desert landscape",
  "Underwater scene",
  "Space environment",
  "Cozy interior",
  "Industrial setting",
  "Magical realm",
  "Cyberpunk City",
  "Post-apocalyptic ruins"
];

export const audioDescriptions = [
  "Distant city sirens",
  "Gentle ocean waves",
  "Bustling crowd chatter",
  "Peaceful bird songs",
  "Rhythmic machinery",
  "Soft piano melody",
  "Thunder and rain",
  "Crackling fireplace",
  "Wind through trees",
  "Ambient electronic sounds",
  "Cinematic orchestral swell",
  "Low frequency hum"
];

export const dialogues = [
  "It wasn't about the destination. It was about the journey we never took.",
  "The future belongs to those who believe in the beauty of their dreams.",
  "Sometimes the smallest step in the right direction ends up being the biggest step of your life.",
  "In the midst of winter, I found there was, within me, an invincible summer.",
  "The only way to do great work is to love what you do.",
  "Life is what happens to you while you're busy making other plans.",
  "The best time to plant a tree was 20 years ago. The second best time is now.",
  "Be yourself; everyone else is already taken.",
  "Two things are infinite: the universe and human stupidity.",
  "Yesterday is history, tomorrow is a mystery, today is a gift."
];

export const colorPalettes = [
  { name: "Sunset Orange", colors: ["#FF6B35", "#F7931E", "#FFD23F"] },
  { name: "Ocean Blue", colors: ["#006BA6", "#0496FF", "#FFBC42"] },
  { name: "Forest Green", colors: ["#2D5016", "#61A5C2", "#A9D6E5"] },
  { name: "Purple Dream", colors: ["#7209B7", "#A663CC", "#F8BBD9"] },
  { name: "Warm Autumn", colors: ["#D2001C", "#FFAA44", "#F4D03F"] },
  { name: "Cool Winter", colors: ["#2E86AB", "#A23B72", "#F18F01"] },
  { name: "Vintage Sepia", colors: ["#8B4513", "#DEB887", "#F5DEB3"] },
  { name: "Neon Cyberpunk", colors: ["#FF0080", "#00FFFF", "#FFFF00"] },
  { name: "Pastel Spring", colors: ["#FFB3BA", "#BAFFC9", "#BAE1FF"] },
  { name: "Monochrome", colors: ["#000000", "#808080", "#FFFFFF"] }
];

export const aiModels = [
  "Google Veo 3.1",
  "OpenAI Sora 2.0",
  "Runway Gen-3 Alpha",
  "Kling 1.5",
  "Luma Dream Machine",
  "Hailuo AI",
  "Pika Art 1.0",
  "Stable Video Diffusion"
];